export default {
  title: "Сменить пароль",
  modal: {
    title: "Сменить пароль",
    form: {
      old_password: {
        label: "Старый пароль",
        placeholder: "Введите старый пароль",
      },
      new_password: {
        label: "Новый пароль",
        placeholder: "Введите новый пароль",
      },
      repeat_new_password: {
        label: "Повторите новый пароль",
        placeholder: "Повторите новый пароль",
      },
      button: {
        close: "Закрыть",
        save: "Сохранить"
      },
    },
  },
}
